import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';
import { Input, Button, Select } from '../../../../components/base';
import { formatData,  normalizeAmount } from '../../../../utils/transformer.util';
import ListForm from '../../../../components/ListForm/ListForm.component';
import ContentTable from '../../../../components/ContentTable/ContentTable.component';
import { KELAS_DATAKELAS_TABLE_FIELDS } from '../../../../constants/Akademi/DataKelas/kelas.constant';
import { SEARCH_FIELDS} from '../../../../constants/Akademi/DataKelas/kelas.constant';
import {TAMBAH_UANG_SEKOLAH_FORM}   from '../../../../constants/finance/spp/tambah-uang-sekolah.constant';
import {Link} from 'react-router-dom';

export default class DataKeuDetail extends PureComponent {
  constructor(props) {
    super(props);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickEdit = this._onClickEdit.bind(this);
    this._onClickSettingan = this._onClickSettingan.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
  
    this.state= {
      coa: {
        loading: true,
        list: [],

      },
      form: {
        value: {},
        error: {},
      },
    };
  
  }

  _onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/spp/tambah-uang-sekolah', { data: '' });
  }

  _onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/keuangan/spp/settingan-uang-sekolah', { data: val });
  }

  _onClickSettingan() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/spp/settingan-uang-sekolah');
  }
  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      checked,
      type,
    } = event.target;
    const {
      inputType = 'text', inputArray = false, arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray
              ? { [fieldName]: newListError }
              : { [name]: '' }),
          },
        },
      };
    });
  }
  onFormChange(event) {
    const {
      name,
      value,
      dataset,
    } = event.target;
    console.log(name)
    const { inputArray = false, arrayPosition = 0, inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      let newPlafon = [];
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }

      if (inputArray) {
        newPlafon = prevState.form.value.plafon;
        newPlafon[arrayPosition][name] = value;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray ? 
              { plafon: newPlafon } : 
              { [name]: formattedValue }
            )
          },
          error: {
            ...prevState.form.error,
            form:'',
            [name]: '',
          },
        },
      };
    });
  }


  render() {
    const {form} = this.state;
    const { handleGetKelas, handleDeleteKelas,coa } = this.props;
    return (
      
       
        <div className="budget__content">
           
          <div className="upload-nilai__body">
            <table className="upload-nilai__table">
                    <thead>
                      <tr>
                        <th>Jenis</th>
                        <th>Mata Uang</th>
                        <th>Nominal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {
                      map(journal.details, (list, idx) => (
                        <tr key={`journal_detail_${idx}`}>
                          <td>{idx + 1}</td>
                          <td>{list.code_of_account}</td>
                          <td>{list.parameter_code.title}</td>
                          <td>{list.description}</td>
                          <td className="nominal">{commaFormatted(list.amount)}</td>
                        </tr>
                      ))
                    } */}
                    <tr>
                       <td>US-Uang Sekolah</td>
                       <td>
                           <Select
                            // value={to}
                            name="mata_uang_US"
                            onChange={this._onFormChange}
                            placeholder={"pilihan"}
                            value={form.value.mata_uang}
                            error={form.error.mata_uang}
                           />
                       </td>
                       <td>
                       <Input
                          type="number"
                          name="nominal_US"
                          onChange={this._onFormChange}
                          placeholder={"pilihan"}
                          value={form.value.nominal_US}
                          error={form.error.nominal_US}
                         />
                       </td>
                       
                      
                    </tr>
                    <tr>
                     <td>UP-Uang Pangkal</td>
                     <td>
                           <Select
                            // value={to}
                            name="mata_uang_UP"
                            onChange={this._onFormChange}
                            placeholder={"pilihan"}
                            value={form.value.mata_uang_UP}
                            error={form.error.mata_uang_UP}
                           />
                       </td>
                    <td>
                    <Input
                         type="number"
                         name="nominal_UP"
                         onChange={this._onFormChange}
                         placeholder={"pilihan"}
                         value={form.value.nominal_UP}
                         error={form.error.nominal_UP}
                         />
                    </td>

                    </tr>
                    <tr>
                        <td>USRGM-Uang Seragam</td>
                        <td>
                           <Select
                            // value={to}
                            name="mata_uang_usrgm"
                            onChange={this._onFormChange}
                            value={form.value.mata_uang_usrgm}
                            error={form.error.mata_uang_usrgm || ''}
                            placeholder={"Pilihan"}
                           />
                       </td>
                       <td>
                       <Input
                          type="number"
                          name="nominal_usrgm"
                          onChange={this._onFormChange}
                          value={form.value.nominal_usrgm}
                          error={form.error.nominal_usrgm ||''}
                          />
                       </td>
                    
                    </tr>
                   
                    </tbody>
                  </table>
                  </div>
                  <div className="add-upload-rapbu">
                    <Button
                    title="Simpan Data"
                    onClick={this._onClickAdd}
                    />
                </div>
        </div>
    );
  }
}
DataKeuDetail.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
DataKeuDetail.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
